<template>
  <div>
    <PageHeader title="My Entries"></PageHeader>
    <div v-if="entries && entries.length === 0">
      <h3>You have no entries</h3>
      <div>
        <router-link :to="{name: 'active-competitions'}">Go to competitions</router-link>
      </div>
    </div>
    <div v-if="activeEntries && activeEntries.length > 0">
      <v-container>
        <v-row>
          <v-col class="text-right">
            <router-link :to="{name: 'active-competitions'}">Competitions</router-link>
          </v-col>
        </v-row>
      </v-container>
      <v-card
        outlined
        v-for="entry in activeEntries" :key="entry.id"
        class="mb-4"
      >
        <v-container>
          <v-row>
            <v-col>
              <EntryHeader :entry="entry"></EntryHeader>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col class="pb-4" style="text-align: center;">
              <CountdownClock 
              :date="entry.competitionOpenDate" 
              title="Voting and Rating opens in" 
              blockClass="countdown-digit-green"
              :endShowLink="true"
              linkName="entry-home"
              :linkText="entryHomeLinkText(entry)"
              :entry="entry"
              endText="Voting is open"
              :displayTime="entry.competitionOpenDate | moment('HH:mm')"></CountdownClock>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
    <v-container class="pa-0">
      <v-row>
        <v-col>
          <router-link :to="{name: 'expired-entries'}">Go to expired entries</router-link>
        </v-col>
      </v-row>
    </v-container>
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import Spinner from './../../components/Spinner';
import EntryHeader from './EntryHeader';
import _ from "lodash";
import moment from "moment";
import CountdownClock from './CountdownClock.vue';

export default {
  name: 'myentries',
  components: {
    PageHeader,
    Spinner,
    EntryHeader,
    CountdownClock
  },
  data: () => ({
    overlay: false,
    headers: [
      { text: 'Username', value: 'userName' }
    ],
    entries: null
  }),
  computed: {
    activeEntries () {
      if(this.entries && this.entries.length > 0) {
        return _.filter(this.entries, (o) => {
          return moment(o.competitionEndDate).unix() > moment().unix();
        });
      } else {
        return null;
      }
    }
  },
  methods: {
    getEntries: function () {
      var scope = this;
      this.$store.dispatch('getEntries').then(response => {
        scope.entries = response;
        this.overlay = false;
      }, error => {
          this.overlay = false;
          console.log(error);
      });
    },
    goToEntryHome: function (id) {
      this.$router.push({name: 'entry-home', query: {entryId: id}});
    },
    entryHomeLinkText: function (entry) {
      var tasks = 0;
      if(!entry.answered)
        tasks++;
      if(!entry.voted)
        tasks++;
      if(tasks === 0){
        return 'View entry details here';
      } else {
        return `Complete ${tasks} required ${tasks === 1 ? 'action': 'actions'} here`;
      }
    }
  },
  created () {
    this.overlay = true;
    this.getEntries();
  }
}
</script>